<table class="default-table" [attr.aria-label]="tableLabel">
    <thead>
        <tr>
            <th *ngFor="let header of headers">
                <ng-container *ngIf="header.hasFilters else noFilters">
                    <div class="row-header" style="cursor: pointer;" (click)="onSort(header)">
                        <span>{{ header.name }}</span>
                        <img src="assets/icons/{{orderIcon}}.svg" class="order-icon" alt="arrow">
                    </div>
                    <input *ngIf="enableFilters && !header.options" class="filter-input" placeholder="Filtrar"
                        type="text" (input)="onSearch(header, $event)">
                    <select *ngIf="enableFilters && header.options" class="filter-select"
                        (change)="onSearch(header, $event)">
                        <option [ngValue]="null" selected disabled hidden>Seleccione</option>
                        <option *ngFor="let option of header.options | keyvalue" [value]="option.key">{{ option.value }}
                        </option>
                    </select>
                </ng-container>
                <ng-template #noFilters>
                    <div class="row-header">
                        <span>{{ header.name }}</span>
                    </div>
                </ng-template>
            </th>
        </tr>
    </thead>
    <tbody>
        <ng-content select="[tableBody]">
        </ng-content>
    </tbody>
</table>